module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#cricket",
      toString: function () {
        return this.url;
      }
    }